<template>
  <div class="container">
    <div class="row card p-4">
      <!-- <div class="col-md-12">
        <boton-atras :nombre_ruta="'Menu'"/>
      </div> -->
      <div class="col-md 12">
        <h3 class="">2025-2001</h3>
      </div>
      <div class="col-12 mt-2" v-if="yearOptions">
          <label class="labelTextarea">Seleccione año a consultar</label>
          <px-select idSelect="anio_pe" placeholder="Seleccione" :options="yearOptions" @KuramaSelect="anioSelected = $event"></px-select>
      </div>
      <!-- {{ yearOptions }} -->
    </div>
    <div v-if="data" class="col-md-12 p-0">
      <!-- <card-collapse-docs  :sections="data" :collapse="true" :urlServe="urlServe" /> -->
      <table-section :sections="data" :urlServe="urlServe"/>
      <div class="mb-4"><span v-html="fecha_actualizacion"></span></div>
    </div>
  </div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import PresupuestoEgresos from "@/services/rendicionDeCuentas/presupuestosEgresos/presupuestoEgresos.js";
const _serviciosPresupuestoEgresos= new PresupuestoEgresos();
import mixin from "@/mixins/mixin.js";
import selectEjercicio from "../../../components/selectEjercicio.vue";
import cardCollapse from "../../../components/cardCollapse.vue";
import cardCollapseDocs from '../../../components/cardCollapseDocs.vue';
import botonAtras from './../../button-atras.vue'
import tableSection from '../../../components/table.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  components: { selectEjercicio, cardCollapse, cardCollapseDocs, botonAtras, tableSection},
  mixins: [DateFormat],
  data() {
    return {
      data: [],
      dataAll: [],
      yearOptions: [],
      loading: false,
      anioSelected: null,
      sectionData:[],
      fecha_actualizacion: '',
    };
  },
  async created() {
    await this.getPresupuestoEgresos();
  },
  methods: {
    async getPresupuestoEgresos() {
        try {
            const response = await _serviciosPresupuestoEgresos.getPresupuestoEgresos(mapFun.presupuestoEgresos);
            this.dataAll = response.data
            let fecha_texto = this.dataAll[0].fecha_actualizacion;
            this.fecha_actualizacion = this.DateFormatText(fecha_texto);
        } catch (error) {
            console.log('error', error.message);
        }
    },
    async getAniosDocs() {
      try {
        this.yearOptions = this.dataAll.map(function (mapeoSelect) {
          return {
            id: mapeoSelect.id,
            value: mapeoSelect.titulo,
            text: mapeoSelect.titulo,
          };
        });
      } catch (error) {
        console.log("error", error.message);
      }
    },
    async getPresupuestoEgresosporAnio() {
        try {
            // Filtrar los datos por el año seleccionado
            this.data = this.dataAll.filter(item => item.titulo === this.anioSelected.value);
        } catch (error) {
            console.log('error', error.message);
        }
    },
  },
  watch: {
    dataAll(){
      if(this.dataAll){
        this.getAniosDocs();
      }
    },
    anioSelected() {
      this.getPresupuestoEgresosporAnio();
    },
  },
};
</script>
<style scoped>
.card{border: none;}
</style>